import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { switchMap, map, first, filter} from 'rxjs/operators';
import { Observable, Subscription, combineLatest, timer} from 'rxjs';
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { GenericLambdaReturn } from '../models/genericLambda';
import { TasklistService, TaskListType, TaskType, StatusType, EAMPriorWorkRequest } from '../services/tasklist.service'
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { TaskCompleteDialog } from './task-complete-complete'
import { DidNotCompleteDialog } from './did-not-complete-dialog';
import { ShiftDateShareService } from '../services/shift-date-share.service';
import { ClearTaskDialog } from './clear-task-dialog';
import { TaskFileDialog } from './task-file-dialog/task-file-dialog.component';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { ObjectListService, ObjectNode } from '../services/object-list.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { EamAssociateDialog } from './eam-associate-dialog/eam-associate-dialog.component';
import { MatButton, MatIconButton } from '@angular/material/button';
import { NgIf, NgClass, NgFor, AsyncPipe, DatePipe } from '@angular/common';
import { MatDivider } from '@angular/material/list';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardTitleGroup, MatCardTitle, MatCardContent } from '@angular/material/card';
import { DateConversionPipe } from '../pipes/date-conversion.pipe';
import { TaskListDownloadDialog } from './task-list-download.component'

export interface taskListItem {
  id: number 
  comment: string 
  corective_action: string 
  tag_no: string 
  completed: number
  type: number
  tasktitle: string
}

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.scss'],
    imports: [MatButton, NgIf, NgClass, MatDivider, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgFor, MatCard, MatCardTitleGroup, MatCardTitle, MatIconButton, MatCardContent, AsyncPipe, DatePipe, DateConversionPipe]
})
export class TaskListComponent implements OnInit, OnDestroy {
  dataSource:MatTableDataSource<TaskType>
  mDataSource: TaskType[]
  statusDatasource: StatusType;
  shift: any;
  statusValue: string = "VALUE"
  site: string;
  environment: string;
  object: string;
  selectedTaskType: string = "";
  selectedLastCompleted: string;
  selectedRevision: any;
  selectedFormNumber: any;
  showDidNotCompleteAllButton: boolean;
  isTablet$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])
  isScreen$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
  columns: string[]=["type", "task", "time", "otherinfo", "issueFound", "tag"];
  objAliasTitle: string;
  dsShiftList:{};
  selectedShiftDate: string;
  selectedShift: string;
  @ViewChild(MatSort) sort: MatSort;
  subscription: Subscription;  
  shiftSubscription: Subscription;
  timer$: Subscription;
  objInfoObj: any;
  objInfoOb: any;
  shiftDateTitle: string;
  shiftTitle: string;
  objInfoObcombine: Subscription;
  checkListType: string;
  mode: string;
  editMode: boolean;
  lineTitle: string;
  siteTitle: string;
  eamAsset: string;
  tasktitle: string;
  requireComment: boolean;
  optionalComment:boolean;
  requireWorkRequest:Number;
  defaultEAMAsset:boolean;

  readOnlyuser: boolean = false;
  

  synth = window.speechSynthesis;
  voice: SpeechSynthesisVoice;
  voicePitch: number;
  voiceRate: number;

  constructor(
    private service: TasklistService,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private objListService: ObjectListService,
    private shiftDateShare: ShiftDateShareService,
    private toastr: ToastrService,
    private geaMesCognito: GeaMesCognitoAuthService,
    private router: Router
  ) {  
    this.site = this.route.snapshot.paramMap.get('site');
    this.environment = this.route.snapshot.paramMap.get('environment');
    this.object = this.route.snapshot.paramMap.get('object');
    this.checkListType = this.route.snapshot.paramMap.get('checklistType');
    this.mode = this.route.snapshot.paramMap.get('mode');
    this.editMode = (this.mode == "ACTIVE") ? true : false;
    this.dataSource = new MatTableDataSource<TaskType>();

    this.geaMesCognito.isUserEmployeeOrAuthorized().pipe(filter(x => x!= null),first()).subscribe(
      employee => {
        if (!employee) {
          this.readOnlyuser = true;
        } else {
          this.readOnlyuser = false;
        }
      }
    )
  }

  ngOnInit() {
    let voices = this.synth.getVoices();
    for (let i = 0; i < voices.length; i++) {
      if (voices[i].lang === 'en-US') {
        if (voices[i].name === "Microsoft Emma Online (Natural) - English (United States)") {
          this.voice = voices[i];
          break;
        }
        else if (voices[i].name === "Google US English") {
          this.voice = voices[i];
          break;
        }
        else if (voices[i].name === "Samantha") {
          this.voice = voices[i];
          break;
        }
        else {
          this.voice = voices[i];
        }
      }
    }
    this.voicePitch = 1;
    this.voiceRate = 1;

    this.selectedTaskType = "";
    const objShiftInfo = combineLatest(
      this.shiftDateShare.objDesctiptOb,
      this.shiftDateShare.shiftDateOb,
      this.shiftDateShare.shiftOb
    ).pipe(map(([objDescript, shiftDate, shift]) => {
      return {objDescript, shiftDate, shift}
    }))

    objShiftInfo.subscribe((selectedObj) => {
      if (selectedObj.objDescript == "" || selectedObj.shiftDate == "" || selectedObj.shift == ""){
        this.router.navigate(['/tasklist', this.site, this.environment, this.object])
      }
      this.selectedShift = selectedObj.shift
      this.selectedShiftDate = selectedObj.shiftDate
      this.objAliasTitle = selectedObj.objDescript
      this.getObjectDescription(this.site, this.object)
      this.fetch()
    })
  }

  unSelectShift() {
    this.router.navigate(['/tasklist', this.site, this.environment, this.object])
  } 

  fetch(){

    this.dataSource.filterPredicate = (data: TaskType, filter: string) => {
      return data.task_type == filter;
    };
    this.dataSource.sort=this.sort;

    let d: Observable<GenericLambdaReturn<TaskListType>> =
      this.route.paramMap.pipe(
        switchMap((params:ParamMap) =>
        this.service.taskList(this.site, this.environment, this.object, this.selectedShiftDate, this.selectedShift))
      )
    
    
      if (this.subscription) this.subscription.unsubscribe();     

    this.subscription = d.subscribe((next) => {
      next.Body.status.SHIFT = (next.Body.status.SHIFT === undefined) ? {"last_complete_date": "", "completed_tasks": 0, "total_tasks": 0} : next.Body.status.SHIFT
      next.Body.status.WEEK = (next.Body.status.WEEK === undefined) ? {"last_complete_date": "", "completed_tasks": 0, "total_tasks": 0} : next.Body.status.WEEK
      next.Body.status.BIWEEKLY = (next.Body.status.BIWEEKLY === undefined) ? {"last_complete_date": "", "completed_tasks": 0, "total_tasks": 0} : next.Body.status.BIWEEKLY
      next.Body.status.MONTH = (next.Body.status.MONTH === undefined) ? {"last_complete_date": "", "completed_tasks": 0, "total_tasks": 0} : next.Body.status.MONTH
      this.dataSource.data=next.Body["tasks"];
      this.dataSource.sort=this.sort;
      this.selectedTaskType = this.checkListType;
      this.dataSource.filter=this.selectedTaskType;
      this.mDataSource =this.dataSource.filteredData;

      this.statusDatasource = next.Body["status"]
      this.shift = (next.Body["status"]["SHIFT"] == null || next.Body["status"]["SHIFT"] == undefined) ? next.Body["status"]["SHIFT"] : [];
      this.selectedLastCompleted = (this.statusDatasource[this.selectedTaskType] == null || this.statusDatasource[this.selectedTaskType] == undefined) ? '' : this.statusDatasource[this.selectedTaskType].last_complete_date;
      this.selectedRevision = (this.statusDatasource[this.selectedTaskType] == undefined) ? '' : this.statusDatasource[this.selectedTaskType].revision;
      this.selectedFormNumber = (this.statusDatasource[this.selectedTaskType] == undefined) ? '' : this.statusDatasource[this.selectedTaskType].form_number;
      
      this.showDidNotCompleteAll()

      if (this.mode != 'ACTIVE'){
        this.setFilter(this.checkListType)
        this.editMode = true
      } else {
        this.editMode = false
      }
    },
    (err) => {
      console.error("AN ERROR OCCURRED!!");
      console.error(err);

      if (this.service.isRerunnable(err)) {
        console.log("This is a rerunnable failure");

        if (!this.timer$ || this.timer$.closed) {
          let waitTime:number = this.service.randomInt(30000, 60000);
          console.warn(`Retrieve tasklist failed, waiting ${waitTime}ms before trying again.`)
          this.timer$ = timer(waitTime).subscribe((next) => {
              console.info("Trying to retrieve tasklist again after prior failure.");
              this.timer$.unsubscribe(); // Clean up this subscription
              this.fetch();
          });
        }
      } else {
        console.error("Failure is client side, do not rerun but warn the user somehow");
      }
    });
  }

  markOK(id:number, task:TaskType) {
    console.debug("markOK Require: ", this.requireComment," Optional:", this.optionalComment);

    if (this.requireComment || this.optionalComment || (task.required_input && task.required_input != '')) {
      let width:string;
  
      if (this.isScreen$) {
        width ='500px';
      } else {
        width = '500px';
      }

      const dialogRef = this.dialog.open(TaskCompleteDialog, {
        width: width,
        data: 
          {
            site: this.site, 
            id: id, 
            comment: '', 
            correctiveAction: '', 
            tagno: '', 
            completed: 0, 
            type: 5, // Set Dialog in comment only mode 
            editMode: this.editMode, 
            eamAsset: this.eamAsset, 
            siteTitle: this.siteTitle,
            lineTitle: this.lineTitle,
            objAliasTitle: this.objAliasTitle,
            requireComment: this.requireComment,
            optionalComment: this.optionalComment,
            requireWorkRequest: this.requireWorkRequest,
            defaultEAMAsset: this.defaultEAMAsset,
            task: task,
            readOnlyuser: this.readOnlyuser
          }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('return from complete dialog:', result)
        if (result != undefined) {
            this.complete(result.id, result.comment, result.correctiveAction, result.tagno, 1, result.input_data); // Record OK
        }
      });
    } else {
      this.complete(id,'','','',1); // Record OK
    }
  }

  complete(id: number, comment?: string, correctiveAction?: string, tagno?: string,status?:number, inputData?: string) {
    this.service.completeTask(id, this.site, comment, correctiveAction, tagno, status, inputData).subscribe(out => {
      this.fetch();
    })
  }

  setFilter(tasktype: string) {
    this.selectedTaskType = tasktype;
    this.dataSource.filter=this.selectedTaskType;
    this.mDataSource =this.dataSource.filteredData;
    this.selectedLastCompleted = this.statusDatasource[tasktype].last_complete_date;
    this.selectedRevision = this.statusDatasource[this.selectedTaskType].revision;
    this.showDidNotCompleteAll()    
  }

  openfiles(task:TaskType):void {
    const dialogRef = this.dialog.open(TaskFileDialog, {
      width: '800px',
      maxHeight: '800px',
      data: {task: task,
            site: this.site,
            environment: this.environment,
            object: this.object
      }
    });

  }

  viewComments(task: TaskType){
    let type: number

    if (task.completed == 1) {
      type = 6
    } if (task.completed == 2){
      type = 3
    } else if (task.completed == 3){
      type = 4
    }
    this.openCompleteDialog(task.id, 1, task) 
  }
  
  markNotOk(id: number, task:TaskType) {
    let toastrOpts:Partial<IndividualConfig> = {
        disableTimeOut: false,
        timeOut: 20000,
        positionClass: "toast-center-center",
        tapToDismiss: false,
        progressBar: false
    };

    this.toastr.info("Checking for Open EAM Work Request or Work Order.", "Processing", toastrOpts);  

    this.service.eamCheck(id).subscribe(
      (out:GenericLambdaReturn<any>) => {
        this.toastr.clear();
        let check:EAMPriorWorkRequest = out.Body;

        if (check.PriorWorkRequest) {
          // OPEN DIALOG FOR ASSOCIATE PRIOR

           const dialogRef = this.dialog.open(EamAssociateDialog, {
              width: '500px',
              data: {
                Site: this.site,
                id: id,
                priorRequest: check,
                required_input: task.required_input
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result && result.OpenNext) {
                this.openCompleteDialog(id, 1, task);
              } else if (result && result.Fetch) {
                this.fetch();
              } else {
                console.debug("Do not open dialog, either canceled or complete");
              }
              
            });
        } else {
          // No priory EAM Work Request/Order, just go to dialog
          this.openCompleteDialog(id, 1, task);
        }
      }
    )
  }

  openCompleteDialog(id: number, type: number, task:TaskType) {
    let width:string;
    type = type ? type:1
    
    if (this.isScreen$) {
      width ='500px';
    } else {
      width = '500px';
    }
    const dialogRef = this.dialog.open(TaskCompleteDialog, {
      width: width,
      data: 
        {
          site: this.site, 
          id: id, 
          type: type, 
          editMode: this.editMode, 
          eamAsset: this.eamAsset, 
          siteTitle: this.siteTitle,
          lineTitle: this.lineTitle,
          objAliasTitle: this.objAliasTitle,
          requireComment: this.requireComment,
          requireWorkRequest: this.requireWorkRequest,
          defaultEAMAsset: this.defaultEAMAsset,
          task: task,
          readOnlyuser: this.readOnlyuser
        }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (result.type == 2 || result.type == 4) {
          this.complete(result.id, result.comment, result.correctiveAction, result.tagno, 3, result.input_data); // Did not complete
        } else if (result.type == 5 || result.type == 6) {
            this.complete(result.id, result.comment, result.correctiveAction, result.tagno, 1, result.input_data); // Complete
        } else {
          this.complete(result.id, result.comment, result.correctiveAction, result.tagno, 2, result.input_data); // Issue Found, not OK
        }
      }
    });
  }

  showDidNotCompleteAll(): void {
    let statusData = this.statusDatasource
    if (this.selectedTaskType == "SHIFT" && statusData["SHIFT"].completed_tasks == 0) {
      this.showDidNotCompleteAllButton = true
    } else if (this.selectedTaskType == "WEEK" && statusData["WEEK"].completed_tasks == 0) {
      this.showDidNotCompleteAllButton = true
    } else if (this.selectedTaskType == "BIWEEKLY" && statusData["BIWEEKLY"].completed_tasks == 0) {
      this.showDidNotCompleteAllButton = true      
    } else if (this.selectedTaskType == "MONTH" && statusData["MONTH"].completed_tasks == 0){
      this.showDidNotCompleteAllButton = true
    } else if (this.selectedTaskType == "ANNUAL" && statusData["ANNUAL"].completed_tasks == 0){
      this.showDidNotCompleteAllButton = true
    } else {
      this.showDidNotCompleteAllButton = false
    }
  }

  didNotCompleteAll(): void {
    let width:string;
    

    if (this.isScreen$) {
      width ='500px';
    } else {
      width = '250px';
    }
    const dialogRef = this.dialog.open(DidNotCompleteDialog, {
      width: width,
      maxHeight: '500px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      let ids = this.dataSource.filteredData.map(data => data.id)
      if (result != undefined) {
        if (result.deleteFlag == true) {
          this.service.postDidNotCompleteList(ids, result.comment, this.site).subscribe((data => {
            this.fetch()
          }))
        } else {
          console.warn("Did Not Complete Cancelled")
        }
      }
    });
  }

  unsubscribe() {
    if (this.subscription) this.subscription.unsubscribe();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.shiftSubscription) this.shiftSubscription.unsubscribe();
    if (this.objInfoObcombine) this.objInfoObcombine.unsubscribe();
    this.synth.cancel()
  }

  getObjectDescription(site: string, obj: string){
    this.objListService.objectList().subscribe( 
          out=> {
            let sites:ObjectNode[] = out.Body.filter( x => [this.environment].includes(x.environment));

            for (const site of sites) {
              if (site.children) {
                let foundNode = this.objListService.findObject(site.children, this.object);

                if (foundNode) {
                  this.objAliasTitle = foundNode['description'] || this.object;
                  this.lineTitle = foundNode['Level1'] || '';
                  this.siteTitle = site['description'];
                  this.eamAsset = foundNode["EAMAsset"]
                  if (this.eamAsset == "") this.eamAsset = "None"

                  this.requireComment = foundNode['requirecomment'] == 1 ? true : false;
                  this.optionalComment = foundNode['requirecomment'] == 2 ? true: false;
                  this.requireWorkRequest = !Number.isNaN(Number(foundNode['RequireWorkRequest'])) ? foundNode['RequireWorkRequest'] : undefined;
                  this.defaultEAMAsset = foundNode['defaultEAMAsset'] == 1 ? true : false;

                  break;
                }
              }
            }

          }
        )
  }

  navToEam(){
    window.open("https://apex.appl.ge.com/ords/f?p=100")
  }

  clearChecklistItem(id: number, comment: string, correctiveAction: string, tagno: string, status: number, tasktitle:string){
    let width:string;
    console.log(id)
    let checkListItem = {
      id: id,
      comment: comment,
      correctiveAction: correctiveAction,
      tagno: tagno,
      deleteFlag: false,
      status: status,
      tasktitle: tasktitle
    }
    

    if (this.isScreen$) {
      width ='500px';
    } else {
      width = '250px';
    }
    const dialogRef = this.dialog.open(ClearTaskDialog, {
      width: width,
      maxHeight: '500px',
      data: checkListItem
    });

    dialogRef.afterClosed().subscribe(checkListItem => {
      let ids = this.dataSource.filteredData.map(checkListItem => checkListItem.id)
      if (checkListItem != undefined) {
        if (checkListItem.deleteFlag == true) {
          let checkListItem = {
            id: id,
            comment: '',
            correctiveAction: '',
            tagno: '',
            input_data: '',
            status: 0
          }
      
          this.complete(checkListItem.id, checkListItem.comment, checkListItem.correctiveAction, checkListItem.tagno, checkListItem.status, checkListItem.input_data)
        } else {
          console.log("Clear Task Cancelled")
        }
      }
    });

  }

  tts(content:string){
    this.synth.cancel()
    const spokenContent = new SpeechSynthesisUtterance(content.replace(new RegExp("req'd", 'g'),'required'));
    spokenContent.voice = this.voice
    spokenContent.pitch = this.voicePitch
    spokenContent.rate = this.voiceRate
    this.synth.speak(spokenContent)
  }

  downloadExcel(){

    let width:string;
    
    if (this.isScreen$) {
      width ='500px';
    } else {
      width = '500px';
    }
    const dialogRef = this.dialog.open(TaskListDownloadDialog, {
      width: width,
      data: 
        {
          site: this.site, 
          environment: this.environment, 
          objectID: this.object
        }
    });
  }
}
